import { ProgressTracker } from '../plugins/progressTracker/progressTracker'
import { UrPlayerConfig } from '../types'
import { PreSetupHook } from '../urPlayerManager'

const MAX_PERCENTAGE_FOR_CONTINUATION = 97

const getProgramData = (id: number) =>
  ProgressTracker.getSavedData()?.programs[id]

const startAtSavedPosition: PreSetupHook = (
  _id: string,
  urPlayerConfig: UrPlayerConfig,
) => {
  const savedProgramData = getProgramData(urPlayerConfig.urAssetId)

  const percentagePlayed = savedProgramData?.percentage || 0

  const startTimeShouldBeSet =
    percentagePlayed < MAX_PERCENTAGE_FOR_CONTINUATION

  return startTimeShouldBeSet ? { starttime: savedProgramData?.position } : null
}

export default startAtSavedPosition
